import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function NairobiClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Nairobi is in EAT (East Africa Time) - UTC+3
  const nairobiTime = new Date(time.toLocaleString('en-US', {
    timeZone: 'Africa/Nairobi'
  }));
  const hours = nairobiTime.getHours().toString().padStart(2, '0');
  const minutes = nairobiTime.getMinutes().toString().padStart(2, '0');
  const seconds = nairobiTime.getSeconds().toString().padStart(2, '0');
  const date = nairobiTime.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Africa/Nairobi'
  });
  return <div className="bg-gradient-to-br from-teal-500 to-blue-600 text-white p-6 border border-teal-400" data-id="element-119">
      <div className="flex items-center gap-3 mb-4" data-id="element-120">
        <Clock className="w-5 h-5" strokeWidth={1.5} data-id="element-121" />
        <h3 className="text-sm font-light uppercase tracking-widest" data-id="element-122">
          Nairobi Time
        </h3>
      </div>
      <div className="text-5xl font-light mb-2 font-mono tracking-wider" data-id="element-123">
        {hours}:{minutes}:{seconds}
      </div>
      <div className="text-sm font-light opacity-90" data-id="element-124">{date}</div>
      <div className="text-xs font-light opacity-75 mt-2" data-id="element-125">
        East Africa Time (EAT) • UTC+3
      </div>
    </div>;
}